var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#82bcf4;}.cls-2{fill:#6fabe6;}.cls-3{fill:#edebf2;}.cls-4{fill:#dad7e5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Verification") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Verification"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.52,29l1.4,6.54-6.37,2-2,6.37L29,42.52,24,47l-5-4.48-6.54,1.4-2.05-6.37-6.37-2L5.48,29,1,24l4.48-5L4.08,12.5c7.29-2.35,6.32-1.88,6.5-2.46l1.92-6L19,5.48,24,1l5,4.48,6.54-1.4,2,6.37,6.37,2.05L42.52,19,47,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39,37c0,.11.21,0-1.45.55l-2,6.37L29,42.52,24,47l-5-4.48-6.54,1.4-2.05-6.37-6.37-2L5.48,29,1,24l4.48-5L4.08,12.5c7.29-2.35,6.32-1.88,6.5-2.46A27,27,0,0,1,39,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39,24a15,15,0,1,1-27.42-8.42C19.91,3.38,39,9.28,39,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35,28a15,15,0,0,1-2.58,8.42A15,15,0,0,1,11.58,15.58,15,15,0,0,1,35,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.5,20.68l-9.38,9.38a3,3,0,0,1-4.24,0L15.5,26.68a2.12,2.12,0,0,1,3-3l2.5,2.5c11.37-11.37,7.75-7.74,8.5-8.5a2.12,2.12,0,0,1,3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.5,21.68l-8.38,8.38a3,3,0,0,1-4.24,0L15.5,26.68a2.11,2.11,0,0,1-.41-2.41,2.11,2.11,0,0,1,2.41.41l2.5,2.5c11.82-11.82,7.8-7.79,8.66-8.65A2.12,2.12,0,0,1,31.5,21.68Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.8fbd4ac95302070e27ca91afffed36d9.svg";
export { ForwardRef as ReactComponent };